import { ValidationService } from 'projects/services/src/app/validation.service';
import { FORM_TYPE, INPUT_TYPE, VALIDATION_TYPE, FormGroupInterface } from './../types';
import { Validators, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { Validation, FIELD_LENGTH } from './validation';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { DFormGroupComponent } from '../d-form-group/d-form-group.component';

export interface IDFormControl {
	getFormRef(formName: string): AbstractControl;
	getFormElement(formName: string): any;
	makeInputDirty(formName: string[], really?: boolean): boolean;
	makeDirty(really?: boolean): boolean;
	patchValues(nameValueMap: any);
	makeFieldsReadOnly(fieldsName: string[], readOnly?: boolean);
	updateFormValidation(updates: any);
	makeReadOnly(really ?: boolean);
	hideFields(fieldsName: string[], really?: boolean);
	resetFields(fieldName: string[]);
	disableFields(fieldsName: string[], really ?: boolean);
	disableFields(fieldsName: string[], really ?: boolean);
	value(): any;
	getInvalidIds(): string[];
	reset(): void;
	isValid(): boolean;
	markFieldsReadOnlyWithNoValidation(fieldsName: string[], readOnly?: boolean);
}

const STRING = Object.freeze({
	EMPTY_STRING: '',
	THREE_DOT: '...',
	COMMA_SPACE: ', '
});
export class DFormHelpers {

	static makeDirtyAndTouched(formValue: AbstractControl) {
			formValue.markAsDirty();
			formValue.markAsTouched();
		}
	static makePrestineAndUnTouched(formValue: AbstractControl) {
		formValue.markAsPristine();
		formValue.markAsUntouched();
	}

	static forms(formArray: FormGroupInterface): IDFormControl {
		function isValid() {
			let valid = true;
			const formGroup = formArray.forms.map((form: any) => form);
			formGroup.forEach(form => {
				if (!form.formRef.valid) {
					valid = false;
				}
			});
			// let dependentValidities = this.dependentValidities || [];
			// if (!(this.dependentValidities instanceof Array)) {
			// 	dependentValidities = [this.dependentValidities];
			// }
			return valid;
			// const allValid = dependentValidities.reduce((c, p) => c && p, true);
			// if (valid && allValid) {
			// 	return true;
			// }
			// return false;
		}
		function makeInputDirty(formValue: AbstractControl, really: boolean = true) {
			if (formValue) {
				if (really) {
					DFormHelpers.makeDirtyAndTouched(formValue);
				} else {
					DFormHelpers.makePrestineAndUnTouched(formValue);
				}
			}
		}
		function getNotValidElement(formArrays: FormGroupInterface) {
			let invalidElementIds = [];
			for (const form of formArrays.forms){
				const invalidControls = getInvalidControls(form.formRef);
				const elements = form.formElements.filter(element => {
					return invalidControls.includes(element.name);
				});
				const invalidIds = elements.reduce((es, e) => {
					if (e.name) {
						es.push(e.name);
					}
					return es;
				}, []);
				invalidElementIds = invalidElementIds.concat(invalidIds);
			}
			return invalidElementIds;
		}

		function getInvalidControls(form: FormGroup) {
			const invalidControls = [];
			if (!form || form.valid) {
				return invalidControls;
			}
			for ( const control of Object.keys(form.controls)){
				if (!form.controls[control].valid) {
					invalidControls.push(control);
				}
			}
			return invalidControls;
		}
		function makeFieldsReadOnly(form, fieldsName, readOnly) {
			fieldsName.map(elementName => {
					const elementRef = form.getFormRef(elementName);
					const element = form.getFormElement(elementName);
					if (!element) {
						console.warn(`invalid element Name ${elementName}`);
						return;
					}
					element.markAsUntouched = !readOnly;
					if (element._native) {
						for (const key of Object.keys(element._native)) {
							element[key] = readOnly ? false : element._native[key];
						}
					}  else {
						const native = {
							required: element.required,
							atLeastChecked: element.atLeastChecked
						};
						element._native = native;
						for (const key of Object.keys(element._native)) {
							element[key] = readOnly ? false : element._native[key];
						}
					}
					const validators = DFormHelpers.createValidations(
						element,
						false,
						readOnly
					);
					if (elementRef) {
						elementRef.setValidators(validators);
						elementRef.updateValueAndValidity();
					} else {
						console.warn(`${elementName} is not Present in Form`);
					}
				});
		}
		function updateFormValidation(form, updates = {}) {
			const filedNames = Object.keys(updates)
			filedNames.map(elementName => {
				const update = updates[elementName]
				const elementRef = form.getFormRef(elementName);
				const element = form.getFormElement(elementName);
				if (!element) {
					console.warn(`invalid element Name ${elementName}`);
					return;
				}
				Object.assign(element, update);
				const validators = DFormHelpers.createValidations(
					element,
					false,
				);
				if (elementRef) {
					elementRef.setValidators(validators);
					elementRef.updateValueAndValidity();
				} else {
					console.warn(`${elementName} is not Present in Form`);
				}
			})
		}
		function getFormRef (formName: string): AbstractControl {
				let formRef;
				formArray.forms.forEach(form => {
					form.formElements.forEach(formElement => {
						if (formElement.name === formName) {
							if (form.formRef) {
								formRef = form.formRef.controls[formName];
							} else {
								console.warn('Not able to find form Ref:-');
								console.warn(formElement);
							}
							return formRef;
						}
					});
				});
				return formRef ? formRef : false;
		}
		function getFormElement(formName: string): any {
				let element;
				formArray.forms.forEach(form => {
					form.formElements.forEach(formElement => {
						if (formElement.name === formName) {
							element = formElement;
							return element;
						}
					});
				});
				return element ? element : false;
		}

		function getValue(formRef: FormGroup) {
			const formValue = formRef.value;
			for (const property of Object.keys(formValue)) {
				let formProperty = formValue[property];
				if (formProperty instanceof FormGroup) {
					formProperty = getValue(formProperty);
				}
				formValue[property] = (formProperty === '') ? null : formProperty;
			}
			return formValue;
		}

		function getFormElements(): any[] {
			const elements = [];
			formArray.forms.forEach(form => {
				form.formElements.forEach(formElement => {
						elements.push(formElement);
				});
			});
			return elements;
		}
		const methods: IDFormControl = {
			makeInputDirty: (formNames: string[], really = true): boolean => {
				for (const formName of formNames) {
					const formValue = getFormRef(formName);
					if (!formValue) {
						return false;
					}
					makeInputDirty(formValue, really);
				}
				return true;
			},
			isValid: () => {
				return isValid();
			},
			makeDirty: (really = true): boolean => {
				formArray.forms.forEach(form => {
					// form.formRef.markAsDirty();
					// form.formRef.markAsTouched();
					makeInputDirty(form.formRef, really);
					const controls = form.formRef.controls;
					for ( const e in controls) {
						if (controls.hasOwnProperty(e)) {
							const formValue = form.formRef.get(e);
							makeInputDirty(formValue, really);
						}
					}
				});
				return true;
			},
			getFormRef: (formName: string): AbstractControl => {
				return getFormRef(formName);
			},
			getFormElement: (formName: string): any => {
				return getFormElement(formName);
			},
			patchValues: (nameValueMap: any) => {
				if (typeof nameValueMap !== 'object') {
					console.log('Object expecting in patchValues');
					return;
				}
				const keys = Object.keys(nameValueMap);
				const form = DFormHelpers.forms(formArray);
				for (const key of keys) {
					const elementRef = form.getFormRef(key);
					if (elementRef) {
						elementRef.setValue(nameValueMap[key]);
					} else {
						console.warn(`${key} is not Present in Form`);
					}
				}
			},
			getInvalidIds: (): string[] => {
				return getNotValidElement(formArray);
			},
			makeReadOnly(really = true) {
				const form = DFormHelpers.forms(formArray);
				const elements = getFormElements();
				const fieldsName = elements.map(element => element.name);
				makeFieldsReadOnly(form, fieldsName, really);

			},
			makeFieldsReadOnly(fieldsName: string[], really = true) {
				const form = DFormHelpers.forms(formArray);
				makeFieldsReadOnly(form, fieldsName, really);
			},
			updateFormValidation(updates) {
				const form = DFormHelpers.forms(formArray);
				updateFormValidation(form, updates)
			},

			resetFields(fieldsName: string[]) {
				this.hideFields(fieldsName);
				setTimeout(() => this.hideFields(fieldsName, false))
			},

			hideFields(fieldsName: string[], really = true) {
				const form = DFormHelpers.forms(formArray);
				fieldsName.map(elementName => {
					const elementRef = form.getFormRef(elementName);
					const element = form.getFormElement(elementName);
					if (!element) {
						console.warn(`invalid element Name ${elementName}`);
						return;
					}
					element.markAsUntouched = !really;
					if (element._native) {
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}  else {
						const native = {
							required: element.required,
							atLeastChecked: element.atLeastChecked
						};
						element._native = native;
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}
					element.hide = really;
					let validators = DFormHelpers.createValidations(
						element,
						element.disabled
					);
					if (elementRef) {
						if (really) {
							elementRef.clearValidators();
							elementRef.setValue(null);
							validators = [];
						}
						elementRef.setValidators(validators);
						elementRef.updateValueAndValidity();
					} else {
						console.warn(`${elementName} is not Present in Form`);
					}
				});
			},
			value() {
				const value = {};
				formArray.forms.forEach(form => {
					const formName = form.name;
					const hiddenElements = form.formElements
											.filter(element => element.hide)
												.map(element => element.name)
													.reduce((elemMap, e) => {
														elemMap[e] = true;
														return elemMap;
													}, {});
					let formValue = getValue(form.formRef)
					// let formValue = form.formRef.value || null;
					formValue = Object.keys(formValue)
										.reduce((newValue, key) => {
											if (!hiddenElements[key]) {
												newValue[key] = formValue[key] === '' ? null : formValue[key];
											}
											return newValue
										}, {})
					if (formName) {
						value[formName] = formValue === '' ?  null : formValue;
					} else {
						Object.assign(value, formValue);
					}
				});
				return value;
			},
			disableFields(fieldsName: string[], really = true) {
				const form = DFormHelpers.forms(formArray);
				fieldsName.map(elementName => {
					const elementRef = form.getFormRef(elementName);
					const element = form.getFormElement(elementName);
					if (!element) {
						console.warn(`invalid element Name ${elementName}`);
						return;
					}
					element.markAsUntouched = !really;
					if (element._native) {
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}  else {
						const native = {
							required: element.required,
							atLeastChecked: element.atLeastChecked
						};
						element._native = native;
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}
					let validators = DFormHelpers.createValidations(
						element,
						really
					);
					if (elementRef) {
						if (really) {
							elementRef.clearValidators();
							elementRef.setValue(null);
							validators = [];
						}
						elementRef.setValidators(validators);
						elementRef.updateValueAndValidity();
					} else {
						console.warn(`${elementName} is not Present in Form`);
					}

				});
			},
			reset() {
				formArray.forms.forEach(form => {
					if (!form.formRef) {
						return;
					}
					form.formRef.reset();
					form.formElements.forEach(element => {
						element.value = '';
					});
					form.formRef.markAsPristine();
					form.formRef.markAsUntouched();
				});
			},
			markFieldsReadOnlyWithNoValidation(fieldsName: string[], really = false) {
				const form = DFormHelpers.forms(formArray);
				fieldsName.map(elementName => {
					const elementRef = form.getFormRef(elementName);
					const element = form.getFormElement(elementName);
					if (!element) {
						console.warn(`invalid element Name ${elementName}`);
						return;
					}
					element.markAsUntouched = !really;
					if (element._native) {
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}  else {
						const native = {
							required: element.required,
							atLeastChecked: element.atLeastChecked
						};
						element._native = native;
						for (const key of Object.keys(element._native)) {
							element[key] = really ? false : element._native[key];
						}
					}
					let validators = DFormHelpers.createValidations(
						element,
						false,
						really
					);
					if (elementRef) {
						if (really) {
							validators = [];
							elementRef.clearValidators();
						}
						elementRef.setValidators(validators);
						elementRef.updateValueAndValidity();
					} else {
						console.warn(`${elementName} is not Present in Form`);
					}

				});
			}
		};
		return methods;
	}

	static createFormGroupObject(formElements: any[], disable) {
		const group = {};
		let formBuildComplete = false;
		for (const formElement of formElements) {
			const validations = DFormHelpers.createValidations(
				formElement,
				disable,
				formElement.readOnly
			);
			if (formElement.lastElement) {
				formBuildComplete = true;
			}
			group[formElement.name] = [null, validations];
		}
		return {group, formBuildComplete};
	}

	static arrayToSelect(array: string[]) {
		const mappedData = array.map(data => (
			{
				name: data,
				value: data
			}
		));
		return mappedData;
	}

	private static createDurationValidations(formElement, validations) {
		const maxTenureInYears = formElement.maxTenureInYears;
		const minYearTenure = formElement.minTenureInYears;
		const minStartDate = formElement.minStartDate;
		const maxEndDate = formElement.maxEndDate;
		const maxStartDate = formElement.maxStartDate;
		const minEndDate = formElement.minEndDate;
		const fromDateRequired = formElement.fromDateRequired;
		const toDateRequired = formElement.toDateRequired;
		if (maxTenureInYears || minStartDate || maxEndDate || maxStartDate || minEndDate || minYearTenure) {
			validations.push(
				ValidationService.dateDurationValidation(maxTenureInYears, {
					minDate: minStartDate,
					maxDate: maxEndDate,
					maxStartDate,
					minEndDate,
					minYearTenure,
					fromDateRequired,
					toDateRequired,
				})
			);
		} else {
			validations.push(ValidationService.dateDurationValidation(maxTenureInYears, {
				fromDateRequired,
				toDateRequired
			}));
		}
	}

	private static createAadharValidation(formElement, validations) {
		formElement.maxFieldLength = 12;
	}
	private static createUploadValidations(formElement, validations) {
		const required = formElement.required;
		let validationType = formElement.validationType;
		const isCategorised = formElement.isCategorised || false;
		// const isCategorised = formElement.categories && true;
		// const isCategorised = formElement.categories && formElement.categories.length && true;
		if (required) {
			formElement.validationType = validationType =
				VALIDATION_TYPE.FILE;
		}
		const fileTypeValidator: any = isCategorised ? ValidationService.categorisedFileTypeValidator : ValidationService.fileTypeValidator;
		const fileSelectedNotUploaded: any = isCategorised ?
											ValidationService.categorisedFileSelectedNotUploaded :
											ValidationService.fileSelectedNotUploaded;
		if (isCategorised) {
			const categoriesRequired = formElement.categories.reduce((all, current) => {
					all[current] = true;
					return all;
				}, {})
			validations.push(
				ValidationService.categorisedFileRequired(categoriesRequired)
			)
		}
		validations.push(
			fileTypeValidator.apply(
			// ValidationService.fileTypeValidator.apply(
				this,
				formElement.allowedFormats || []
			),
			// ValidationService.allowedFilesCount(2, 0),
			// ValidationService.fileSelectedNotUploaded()
		);
		const maxFiles = formElement.maxFiles;
		const minFiles = formElement.minFiles;
		if (maxFiles || minFiles) {
			validations.push(ValidationService.allowedFilesCount(maxFiles, minFiles))
		}
		validations.push(fileSelectedNotUploaded())
		validations.push(
			ValidationService.fileSizeValidator(formElement.maxSize || 3)
		);
		if (
			formElement.allowedFormats &&
			formElement.allowedFormats.length
		) {
			formElement.info =
				'Allowed formats ' +
				formElement.allowedFormats.join(STRING.COMMA_SPACE);
		}
		return formElement;
	}

	private static createCheckboxGroupValidations(formElement, validations) {
		const { atLeastChecked } = formElement;
		if (atLeastChecked && validations &&validations.length>0) {
			formElement.required = true;
			validations.push(ValidationService.atLeastChecked(atLeastChecked));
		}

	}

	private static createDateValidations(formElement, validations) {
		const {
			minDate,
			maxDate
		} = formElement;
		validations.push(ValidationService.dateValidation({
			maxDate,
			minDate
		}));
	}

	private static createInputGroupValidation(formElement, validations) {
		validations.push(ValidationService.inputGroupValidation());
	}

	private static createValidationTypeValidations(formElement, validations) {
		if (!validations) {
			return;
		}
		let validationType = formElement.validationType;
		switch (validationType) {
			case VALIDATION_TYPE.MOBILE_NUMBER:
				formElement.maxFieldLength = FIELD_LENGTH.MAX_MOBILE_NUMBER || 10;
				formElement.charPattern = '[0-9]';
				formElement.charAllowedPattern = '[0-9]';
				break;
			case VALIDATION_TYPE.LANDLINE_NUMBER:
				formElement.maxFieldLength = FIELD_LENGTH.MAX_LANDLINE || 11;
				formElement.charPattern = '[0-9]';
				formElement.charAllowedPattern = '[0-9]';
				break;
			case VALIDATION_TYPE.DATE_DURATION:
				this.createDurationValidations(formElement, validations);
				break;
			case VALIDATION_TYPE.AADHAR:
				this.createAadharValidation(formElement, validations);
				break;
			default:
				break;
		}
		validationType = Validation[validationType] ? validationType : '';
		if (validationType) {
			const newValidations = Validation[validationType]
				? Validation[validationType].concat(validations)
				: validations;
			Helpers.copyArray(validations, newValidations);
		}
	}
	static createValidations(formElement, disable = false, readOnly = false) {
		formElement.temp = formElement.temp || {};
		formElement.alignClass = [];
		if (formElement.labelDiv !== 0) {
			formElement.alignClass.push(`m-form__group`);
		}
		formElement.alignClass.push(`col-${formElement.align || 12}`);
		if (formElement.type === FORM_TYPE.FORM) {
			formElement.alignClass.push('form-group');
		}

		formElement.readOnly = readOnly;
		formElement['initialDisable'] = formElement.hasOwnProperty(
			'initialDisable'
		)
			? formElement.initialDisable
			: formElement.disabled;

		formElement.disabled = disable ? disable : formElement.initialDisable;
		if (formElement.disabled && !formElement.metaPlaceholder) {
			formElement.temp.placeholder = formElement.placeholder;
			formElement.placeholder = 'N/A';
		} else {
			formElement.placeholder = Helpers.isValidValue(formElement.temp.placeholder) ? formElement.temp.placeholder : formElement.placeholder;
			// formElement.placeholder = formElement.placeholder || formElement.temp.placeholder || '';
		}
		const validationType = formElement.validationType;
		const required = formElement.required;
		const validations = required ? [Validators.required] : [];
		if (formElement.type === INPUT_TYPE.UPLOAD && !formElement.temp) {
			formElement.temp = {};
		}
		switch (formElement.type) {
			case INPUT_TYPE.UPLOAD:
				this.createUploadValidations(formElement, validations);
				break;
			case INPUT_TYPE.CHECKBOX:
				this.createCheckboxGroupValidations(formElement, validations);
				break;
			case INPUT_TYPE.DATE:
				this.createDateValidations(formElement, validations);
				break;
			case INPUT_TYPE.INPUT_GROUP:
				this.createInputGroupValidation(formElement, validations);
				break;
			default:
				break;
		}

		this.createValidationTypeValidations(formElement, validations);

		const { pattern, max, min, minFieldLength, maxFieldLength } = formElement;
		if (pattern) {
			validations.push(Validators.pattern(pattern));
		}
		if (max) {
			validations.push(Validators.max(max));
		}
		if (min) {
			validations.push(Validators.min(min));
		}
		if (maxFieldLength && maxFieldLength > 0) {
			validations.push(Validators.maxLength(maxFieldLength));
		}
		if (minFieldLength && minFieldLength > 0) {
			validations.push(Validators.minLength(minFieldLength));
		}
		return validations;
	}
}
